// src/components/Logo.tsx
//
// Wrapper around the project's logo asset at /logo.png.
// The asset is wide (~5.8:1), so `size` is interpreted as HEIGHT
// and the width auto-scales to preserve aspect. Pass `size={32}`
// to get a 32px-tall logo at its natural proportions.

import React from "react";
import { Box } from "@mui/material";

interface LogoProps {
  /** Display height in pixels. Width scales with aspect ratio. */
  size?: number;
  /** Optional alt text — usually empty (decorative) but pass for screen readers when the logo is the page title. */
  alt?: string;
  /** Pass-through sx for layout tweaks. */
  sx?: any;
}

export const Logo: React.FC<LogoProps> = ({ size = 32, alt = "", sx }) => (
  <Box
    component="img"
    src="/logo.png"
    alt={alt}
    sx={{
      height: size,
      width: "auto",
      maxWidth: "100%",
      objectFit: "contain",
      display: "block",
      flexShrink: 0,
      ...sx,
    }}
  />
);
